import React, { FunctionComponent, useEffect } from 'react';

import { Divider } from '@yandex-360/orb-components/dist/components/Divider';
import cn from 'classnames';
import { useSelector } from 'react-redux';

import { selectIsTelemostDesktopIntegration } from '../../shared/features/config/selectors';
import { countMetrika } from '../../shared/helpers/metrika';
import { ConferenceHistoryList } from './features/history-items/components/list';
import { OneColHeader } from './features/history-items/components/one-col-header';
import { TwoColHeader } from './features/history-items/components/two-col-header';
import { ArtifactsSidebar } from './features/sidebar';
import { useIsOneColLayout } from './hooks';
import { selectIsEmptyResult, selectIsFullFetchingFailed, selectSelectedSession } from './selectors';
import styles from './styles.css';

export const ConferencesHistoryPage: FunctionComponent = () => {
    const isOneColLayout = useIsOneColLayout();
    const selectedSession = useSelector(selectSelectedSession);
    const isResultEmpty = useSelector(selectIsEmptyResult);
    const isFullFetchingFailed = useSelector(selectIsFullFetchingFailed);
    useEffect(() => {
        countMetrika('meeting_history', 'show');
    }, []);
    const isTelemostDesktopIntegration = useSelector(selectIsTelemostDesktopIntegration);
    return (
        <div
            className={cn(styles.ConferenceHistoryPage, {
                [styles.oneColLayout]: isOneColLayout,
                [styles.stub]: isResultEmpty || isFullFetchingFailed,
                [styles.telemostDesktopIntegration]: isTelemostDesktopIntegration,
            })}
        >
            <div className={styles.wrapper}>
                <div className={styles.left}>
                    {isOneColLayout && <OneColHeader />}
                    {!isOneColLayout && (
                        <>
                            <TwoColHeader />
                            <Divider size="sm" />
                        </>
                    )}
                    <ConferenceHistoryList />
                </div>
                {(!isOneColLayout || selectedSession) && (
                    <div className={styles.right}>
                        <ArtifactsSidebar />
                    </div>
                )}
            </div>
        </div>
    );
};
